define('tracks/track-settings',["require", "exports", "../dom", "../util/http", "../views/text-setting", "./jump-type-settings", "./suit-settings", "./video-settings"], function (require, exports, dom_1, http_1, text_setting_1, jumpTypeSettings, suitSettings, videoSettings) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.init = void 0;
    function init(trackId, userId) {
        // Set onclick for delete button
        for (var _i = 0, _a = (0, dom_1.q)(".delete-button"); _i < _a.length; _i++) {
            var deleteButton = _a[_i];
            deleteButton.onclick = function () {
                if (confirm("Delete track? Tracks cannot be un-deleted.")) {
                    (0, http_1.deleteUrl)("/tracks/" + trackId).then(function () {
                        window.location.href = "/tracks";
                    }).catch(function () {
                        alert("Failed to delete track");
                    });
                }
                return false;
            };
        }
        // Edit track location
        var placeSetting = (0, dom_1.q)(".place-name")[0];
        if (placeSetting) {
            new text_setting_1.TextSetting({
                element: placeSetting,
                selectMode: text_setting_1.TextSettingMode.SelectEnd,
                closeOnBlur: true,
                save: function (placename) {
                    return (0, http_1.postJson)("/tracks/" + trackId + "/location", placename)
                        .catch(function (e) { throw new Error("Failed to save location: " + e); });
                }
            });
        }
        // Edit suit
        suitSettings.init(trackId, userId);
        // Edit jump type
        jumpTypeSettings.init(trackId);
        // Edit canopy
        var canopySetting = (0, dom_1.q)(".canopy")[0];
        if (canopySetting) {
            new text_setting_1.TextSetting({
                element: canopySetting,
                selectMode: text_setting_1.TextSettingMode.SelectAll,
                closeOnBlur: false,
                save: function (canopy) {
                    return (0, http_1.postJson)("/tracks/" + trackId + "/canopy", canopy)
                        .catch(function (e) { throw new Error("Failed to save canopy: " + e); });
                }
            });
        }
        // Edit track notes
        var noteSetting = (0, dom_1.q)(".notes")[0];
        if (noteSetting) {
            new text_setting_1.TextSetting({
                element: noteSetting,
                selectMode: text_setting_1.TextSettingMode.SelectEnd,
                closeOnBlur: true,
                save: function (note) {
                    return (0, http_1.postJson)("/tracks/" + trackId + "/note", note)
                        .catch(function (e) { throw new Error("Failed to save note: " + e); });
                }
            });
        }
        // Edit video settings
        videoSettings.init();
    }
    exports.init = init;
});
//# sourceMappingURL=/assets/javascripts/tracks/track-settings.js.map;
